import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalSchedulerGraphicComponent } from 'src/app/components/ui/modal-scheduler-graphic/modal-scheduler-graphic.component';
import { ModalService } from 'src/app/services/modal/modal.service';
import { AstCalendarService } from 'src/app/services/sunTimes/suntimes.service';
import { SchedulerAncComponent } from 'src/app/components/scheduler-anc/scheduler-anc.component';
import Data from './data';

@Component({
    selector: 'app-anc2',
    // standalone: true,
    // imports: [],
    templateUrl: './anc2.component.html',
    styleUrl: './anc2.component.scss',
    standalone: false
})
export class ANC2Component implements OnInit {

  @Input() serial: string = '';
  @ViewChild(SchedulerAncComponent) schedulerAnc?: SchedulerAncComponent;

  data = Data;
  sunTimesData: any[] = [];
  hideSchedulerAnc = false;

  modalScheduler: NgbModalRef;

  constructor(private _modal: ModalService, private astCalendarService: AstCalendarService) { }

  ngOnInit(): void {
    // Calculate sun times for the week using AstCalendarService
    this.sunTimesData = this.astCalendarService.getSunTimesForWeek(
      new Date(),
      this.data.location.lat,
      this.data.location.lon
    );
  }

  // Función para formatear la última conexión
  formatLastSeen(lastseen: string): string {
    if (!lastseen) return 'Nunca';
    const date = new Date(lastseen);
    return date.toLocaleString('es-ES');
  }

  // Obtener el objeto de programaciones para el scheduler-anc
  getSchedulerData(): any {
    return this.data.scheduler || {};
  }

  // Función para abrir el modal de programación
  openSchedulerModal(): void {
    // Hide the background scheduler component to avoid canvas/icon overlap
    this.hideSchedulerAnc = true;

    // If we have a reference to the scheduler component, ask it to pause rendering
    try {
      this.schedulerAnc?.pauseRendering();
    } catch (e) {
      console.warn('Failed to pause schedulerAnc rendering', e);
    }

    const modalRef = this._modal.open(ModalSchedulerGraphicComponent, {
      centered: true,
      scrollable: true,
      windowClass: 'scheduler-window' // clase que usarás en el CSS
    });

    modalRef.componentInstance.schedulerData = this.getSchedulerData();
    modalRef.componentInstance.deviceData = this.data;
    // Pass sunTimesData (calculated array with real astronomical data)
    modalRef.componentInstance.sunTimes = this.sunTimesData;

    modalRef.result.then(
      (result) => {
        // Modal closed with save
        console.log('Modal cerrado con resultado:', result);
        this.hideSchedulerAnc = false;
        try {
          this.schedulerAnc?.resumeRendering();
        } catch (e) {
          console.warn('Failed to resume schedulerAnc rendering', e);
        }
      },
      () => {
        // Modal dismissed without save
        console.log('Modal cerrado sin cambios');
        this.hideSchedulerAnc = false;
        try {
          this.schedulerAnc?.resumeRendering();
        } catch (e) {
          console.warn('Failed to resume schedulerAnc rendering', e);
        }
      }
    );
  }

}
